import { dateUtils } from '@/utils'

export function computeRecurrencePeriod(
  recurrencePeriod: uui.domain.ui.forms.RecurrencePeriod,
): uui.domain.client.rm.RecurrencePeriod {
  switch (recurrencePeriod.recurrenceType) {
    case 'NO_REPEAT': {
      throw new Error('Recurrence period cannot be NO_REPEAT')
    }

    case 'DAILY': {
      return {
        recurrenceType: 'DAILY',
      }
    }

    case 'WEEKLY': {
      if (recurrencePeriod.weekday === undefined) {
        throw new Error('Recurrence period for WEEKLY must have a weekday defined')
      }

      return {
        recurrenceType: 'WEEKLY',
        period: recurrencePeriod.period,
        weekday: dateUtils.toServerWeekday(recurrencePeriod.weekday),
      }
    }

    case 'MONTHLY': {
      if (recurrencePeriod.weekday === undefined && recurrencePeriod.cardinal === undefined) {
        return {
          when: 'ON_DATE',
          recurrenceType: 'MONTHLY',
          period: recurrencePeriod.period,
          date: recurrencePeriod.date,
        }
      }

      if (
        typeof recurrencePeriod.cardinal !== 'number' ||
        typeof recurrencePeriod.weekday !== 'number'
      ) {
        throw new Error('Recurrence period for MONTHLY must have both cardinal and weekday defined')
      }

      return {
        recurrenceType: 'MONTHLY',
        when: 'ON_CARDINAL',
        period: recurrencePeriod.period,
        cardinal: recurrencePeriod.cardinal,
        weekday: dateUtils.toServerWeekday(recurrencePeriod.weekday),
      }
    }

    case 'ANNUALLY': {
      if (
        recurrencePeriod.weekday === undefined &&
        recurrencePeriod.month === undefined &&
        recurrencePeriod.cardinal === undefined
      ) {
        return {
          recurrenceType: 'ANNUALLY',
          when: 'ON_DATE',
          period: recurrencePeriod.period,
          date: recurrencePeriod.date,
        }
      }

      if (
        typeof recurrencePeriod.cardinal !== 'number' ||
        typeof recurrencePeriod.weekday !== 'number' ||
        typeof recurrencePeriod.month !== 'number'
      ) {
        throw new Error(
          'Recurrence period for ANNUALLY must have both cardinal and weekday defined',
        )
      }

      return {
        recurrenceType: 'ANNUALLY',
        when: 'ON_CARDINAL',
        period: recurrencePeriod.period,
        cardinal: recurrencePeriod.cardinal,
        weekday: dateUtils.toServerWeekday(recurrencePeriod.weekday),
        month: recurrencePeriod.month,
      }
    }
  }
}
